import React from "react";
import "./alert.css";
import warningIcon from "../../assets/images/icon-alert-warning.svg";
import SuccessIcon from "../../assets/images/icon-alert-success.svg";
import ErrorIcon from "../../assets/images/error-alert.png";

const Alert = (props) => {
  const hideAlert = () => {
    props.onDisplay("none");
  };

  return (
    <>
      <div
        className={`alert ${
    props.status === 'success'
      ? 'alert-success-newstyle'
      : props.status === 'danger'|| props.status === "dangereux"
      ? 'alert-danger-newstyle': 
       props.status === 'warning'
      ? 'alert-warning-newstyle'
      : `alert-${props.status}`
  } alert-dismissible fade show`}
        style={{marginTop:props.marginTop, position:"relative", display:props.display}}
        role="alert"
      >
        <div className="row">
          <div className="align-self-center">
            {props.status === "warning" ? (
              <img style={{ width: 30 }} src={warningIcon} />
            ) : null}
            {props.status === "danger" || props.status === "dangereux"? (
              <img style={{ width: 30 }} src={ErrorIcon} />
            ) : null}
            {props.status === "success" ? (
              <img style={{ width: 30 }} src={SuccessIcon} />
            ) : null}
          </div>
          <div className="col-10 d-flex flex-column ">
            <span
              className="alerte-popup_title"
              style={{ fontSize: 18, fontWeight: 600 }}
            >
              {" "}
              {props.status === "danger" || props.status === "dangereux" ? "Attention" : null}{" "}
              {props.status === "warning" ? "Attention" : null}{" "}
              {props.status === "success" ? "Bravo" : null}
            </span>
            <span className="alerte-popup_title1" style={{ color: "#B7B7B7" }}
            >
              {" "}
              {props.message}
            </span>
          </div>
          <button type="button" className="close" onClick={hideAlert}>
            <span>&times;</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default Alert;
